import { pgInstanceId } from './constants';
import { isProd } from '@/constants/config';
import {
  translateDataLayerConsumerAdTargets, translateDataLayerConsumerAdTargetsWithoutCAMPBias, translateDataLayerConsumerInsights, translateDataLayerConsumerMarketingSegments,
} from '../utilities/analytics/translatePersonalizationData';
import {
  getLocalStorage, getSignedInStatus, getDataLayerData, getCookie,
} from '../utilities/browserHelpers';
import { getBrowserZipcode } from '@/utilities/akamaiFunctions';

export default async function useDataLayer() {
  const dataLayerData = await getDataLayerData();
  const zip = getBrowserZipcode();
  const pxaId = dataLayerData?.pxaId;
  const pxaIdBackup = dataLayerData?.pxaIdBackup;
  const abc = dataLayerData?.abc;
  const pxaRealId = dataLayerData?.pxaRealId;
  const pixallAbc = dataLayerData?.pixallAbc;
  const isLoggedIn = dataLayerData?.isLoggedIn;
  const peDataJSON = getLocalStorage('pe_data');
  const peData = peDataJSON ? JSON.parse(peDataJSON) : '';

  const consumerInsights = translateDataLayerConsumerInsights(peData?.personalization);
  const consumerAdTargets = translateDataLayerConsumerAdTargets(peData?.consumerAdTargets, peData?.preferences);
  const consumerAdTargetsWithoutCAMPBias = translateDataLayerConsumerAdTargetsWithoutCAMPBias(peData?.consumerAdTargetsWithoutCAMPBias);
  const consumerMarketingSegments = translateDataLayerConsumerMarketingSegments(peData?.consumerMarketingSegments);

  return {
    catalog: 'kbb',
    common: {
      application: {
        name: 'listings',
      },
      user: {
        isLoggedIn,
      },
    },
    consumerInsights: consumerInsights || null,
    consumerAdTargets: consumerAdTargets || null,
    consumerAdTargetsWithoutCAMPBias: consumerAdTargetsWithoutCAMPBias || null,
    consumerMarketingSegments: consumerMarketingSegments || null,
    application: {
      businessUnit: 'kelley blue book',
      name: 'web',
      environment: isProd ? 'production' : 'qa',
      version: '1.0.0',
    },
    page: {
      siteSection: 'own',
      pageType: 'slp_psx',
      detailPageName: 'slp_psx_buy', // if other pages are added, change this dynamically
      pg: 'syc_psx_buy',
      brandPg: 'syc_psx_buy',
      pixallABC: abc || pixallAbc || pxaRealId,
      pixallId: pxaId || pxaIdBackup,
      pixallPageInstanceId: pgInstanceId,
    },
    user: {
      isLoggedIn,
      zipCode: zip,
    },
  };
}
